import { IEditDishContext } from './editDishContext';

export enum EditDishActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	CHANGE_NAME_OF_DISH = 'CHANGE_NAME_OF_DISH',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	CHANGE_POS_NAME = 'CHANGE_POS_NAME',
	CHANGE_EXTERNAL_ID = 'CHANGE_EXTERNAL_ID',
	CHANGE_ARTICLE_NUMBER = 'CHANGE_ARTICLE_NUMBER',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_INITIAL_IDS_RESTAURANT = 'SET_INITIAL_IDS_RESTAURANT',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_SUGGESTED_DISH_CATEGORY = 'SET_SUGGESTED_DISH_CATEGORY',
	SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES = 'SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES',
	SET_SUGGESTED_DISH_SUB_CATEGORY = 'SET_SUGGESTED_DISH_SUB_CATEGORY',
	SET_FETCHED_SUGGESTED_DISHES = 'SET_FETCHED_SUGGESTED_DISHES',
	SET_SUGGESTED_DISHES = 'SET_SUGGESTED_DISHES',
	SET_ADDITIONAL_DISH_CATEGORY = 'SET_ADDITIONAL_DISH_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES = 'SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES',
	SET_ADDITIONAL_DISH_SUB_CATEGORY = 'SET_ADDITIONAL_DISH_SUB_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISHES = 'SET_FETCHED_ADDITIONAL_DISHES',
	SET_ADDITIONAL_DISHES = 'SET_ADDITIONAL_DISHES',
	SET_MODIFICATION_DISH_CATEGORY = 'SET_MODIFICATION_DISH_CATEGORY',
	SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES = 'SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES',
	SET_MODIFICATION_DISH_SUB_CATEGORY = 'SET_MODIFICATION_DISH_SUB_CATEGORY',
	SET_FETCHED_MODIFICATION_DISHES = 'SET_FETCHED_MODIFICATION_DISHES',
	SET_MODIFICATION_DISHES = 'SET_MODIFICATION_DISHES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: EditDishActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditDishContext['needRefetchData'];
	};
}

interface ISetAllData {
	type: EditDishActionTypes.SET_ALL_DATA;
	payload: {
		dishID: IEditDishContext['dishID'];
		type: IEditDishContext['type'];
		isCreatedOnPos: IEditDishContext['isCreatedOnPos'];
		filePath: IEditDishContext['filePath'];
		nameOfDish: IEditDishContext['nameOfDish'];
		description: IEditDishContext['description'];
		initialIDSelectedCustomer: IEditDishContext['initialIDSelectedCustomer'];
		posName: IEditDishContext['posName'];
		externalId: IEditDishContext['externalId'];
		articleNumber: IEditDishContext['articleNumber'];
		initialIDsSelectedRestaurant: IEditDishContext['initialIDsSelectedRestaurant'];
		hasSchedulePriority: IEditDishContext['hasSchedulePriority'];
		activationSchedule: IEditDishContext['activationSchedule'];
		deactivationSchedule: IEditDishContext['deactivationSchedule'];
		translations: IEditDishContext['translations'];
		fetchedSuggestedDishes: IEditDishContext['fetchedSuggestedDishes'];
		selectedSuggestedDishes: IEditDishContext['selectedSuggestedDishes'];
		fetchedAdditionalDishes: IEditDishContext['fetchedAdditionalDishes'];
		selectedAdditionalDishes: IEditDishContext['selectedAdditionalDishes'];
		fetchedModificationDishes: IEditDishContext['fetchedModificationDishes'];
		selectedModificationDishes: IEditDishContext['selectedModificationDishes'];
	};
}

interface IChangeLoaderStatus {
	type: EditDishActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: IEditDishContext['isLoading'];
	};
}

interface ISetFileId {
	type: EditDishActionTypes.SET_FILE_ID;
	payload: {
		fileId: IEditDishContext['fileId'];
	};
}

interface IDeletePhoto {
	type: EditDishActionTypes.DELETE_PHOTO;
}

interface IChangeNameOfDish {
	type: EditDishActionTypes.CHANGE_NAME_OF_DISH;
	payload: {
		nameOfDish: IEditDishContext['nameOfDish'];
	};
}

interface IChangeDescription {
	type: EditDishActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: IEditDishContext['description'];
	};
}

interface ISetFetchedCustomers {
	type: EditDishActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IEditDishContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: EditDishActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditDishContext['IDSelectedCustomer'];
	};
}

interface IChangePosName {
	type: EditDishActionTypes.CHANGE_POS_NAME;
	payload: {
		posName: IEditDishContext['posName'];
	};
}

interface IChangeExternalId {
	type: EditDishActionTypes.CHANGE_EXTERNAL_ID;
	payload: {
		externalId: IEditDishContext['externalId'];
	};
}

interface IChangeArticleNumber {
	type: EditDishActionTypes.CHANGE_ARTICLE_NUMBER;
	payload: {
		articleNumber: IEditDishContext['articleNumber'];
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditDishActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: IEditDishContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: EditDishActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IEditDishContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: EditDishActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IEditDishContext['translations'];
	};
}

interface IToggleHasSchedulePriority {
	type: EditDishActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: EditDishActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditDishContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditDishContext['deactivationSchedule'];
	};
}

interface ISetFetchedRestaurants {
	type: EditDishActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IEditDishContext['fetchedRestaurants'];
	};
}

interface ISetInitialIDsRestaurant {
	type: EditDishActionTypes.SET_INITIAL_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: IEditDishContext['IDsSelectedRestaurant'];
	};
}

interface ISetIDsRestaurant {
	type: EditDishActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: IEditDishContext['IDsSelectedRestaurant'];
	};
}

interface ISetFetchedCategories {
	type: EditDishActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: IEditDishContext['fetchedCategories'];
	};
}

interface ISetSuggestedDishCategory {
	type: EditDishActionTypes.SET_SUGGESTED_DISH_CATEGORY;
	payload: {
		selectedSuggestedDishCategory: IEditDishContext['selectedSuggestedDishCategory'];
	};
}

interface ISetFetchedSuggestedDishSubCategories {
	type: EditDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES;
	payload: {
		fetchedSuggestedDishSubCategories: IEditDishContext['fetchedSuggestedDishSubCategories'];
	};
}

interface ISetSuggestedDishSubCategory {
	type: EditDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY;
	payload: {
		selectedSuggestedDishSubCategory: IEditDishContext['selectedSuggestedDishSubCategory'];
	};
}

interface ISetFetchedSuggestedDishes {
	type: EditDishActionTypes.SET_FETCHED_SUGGESTED_DISHES;
	payload: {
		fetchedSuggestedDishes: IEditDishContext['fetchedSuggestedDishes'];
	};
}

interface ISetSuggestedDishes {
	type: EditDishActionTypes.SET_SUGGESTED_DISHES;
	payload: {
		selectedSuggestedDishes: IEditDishContext['selectedSuggestedDishes'];
	};
}

interface ISetAdditionalDishCategory {
	type: EditDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY;
	payload: {
		selectedAdditionalDishCategory: IEditDishContext['selectedAdditionalDishCategory'];
	};
}

interface ISetFetchedAdditionalDishSubCategories {
	type: EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES;
	payload: {
		fetchedAdditionalDishSubCategories: IEditDishContext['fetchedAdditionalDishSubCategories'];
	};
}

interface ISetAdditionalDishSubCategory {
	type: EditDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY;
	payload: {
		selectedAdditionalDishSubCategory: IEditDishContext['selectedAdditionalDishSubCategory'];
	};
}

interface ISetFetchedAdditionalDishes {
	type: EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES;
	payload: {
		fetchedAdditionalDishes: IEditDishContext['fetchedAdditionalDishes'];
	};
}

interface ISetAdditionalDishes {
	type: EditDishActionTypes.SET_ADDITIONAL_DISHES;
	payload: {
		selectedAdditionalDishes: IEditDishContext['selectedAdditionalDishes'];
	};
}

interface ISetModificationDishCategory {
	type: EditDishActionTypes.SET_MODIFICATION_DISH_CATEGORY;
	payload: {
		selectedModificationDishCategory: IEditDishContext['selectedModificationDishCategory'];
	};
}

interface ISetFetchedModificationDishSubCategories {
	type: EditDishActionTypes.SET_FETCHED_MODIFICATION_DISH_SUB_CATEGORIES;
	payload: {
		fetchedModificationDishSubCategories: IEditDishContext['fetchedModificationDishSubCategories'];
	};
}

interface ISetModificationDishSubCategory {
	type: EditDishActionTypes.SET_MODIFICATION_DISH_SUB_CATEGORY;
	payload: {
		selectedModificationDishSubCategory: IEditDishContext['selectedModificationDishSubCategory'];
	};
}

interface ISetFetchedModificationDishes {
	type: EditDishActionTypes.SET_FETCHED_MODIFICATION_DISHES;
	payload: {
		fetchedModificationDishes: IEditDishContext['fetchedModificationDishes'];
	};
}

interface ISetModificationDishes {
	type: EditDishActionTypes.SET_MODIFICATION_DISHES;
	payload: {
		selectedModificationDishes: IEditDishContext['selectedModificationDishes'];
	};
}

interface ISetDataForSubmit {
	type: EditDishActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditDishContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditDishContext['typeOfModalWindow'];
	};
}

export type TEditDishAction =
	| IRefetchData
	| ISetAllData
	| IChangeLoaderStatus
	| ISetFileId
	| IDeletePhoto
	| IChangeNameOfDish
	| IChangeDescription
	| ISetFetchedCustomers
	| ISetIDCustomer
	| IChangePosName
	| IChangeExternalId
	| IChangeArticleNumber
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetFetchedRestaurants
	| ISetInitialIDsRestaurant
	| ISetIDsRestaurant
	| ISetFetchedCategories
	| ISetSuggestedDishCategory
	| ISetFetchedSuggestedDishSubCategories
	| ISetSuggestedDishSubCategory
	| ISetFetchedSuggestedDishes
	| ISetSuggestedDishes
	| ISetAdditionalDishCategory
	| ISetFetchedAdditionalDishSubCategories
	| ISetAdditionalDishSubCategory
	| ISetFetchedAdditionalDishes
	| ISetAdditionalDishes
	| ISetModificationDishCategory
	| ISetFetchedModificationDishSubCategories
	| ISetModificationDishSubCategory
	| ISetFetchedModificationDishes
	| ISetModificationDishes
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
